var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Text, Stack, Pivot, PivotItem, TextField, PrimaryButton } from 'office-ui-fabric-react';
var TodoHeader = /** @class */ (function (_super) {
    __extends(TodoHeader, _super);
    function TodoHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.onAdd = function () {
            _this.props.addTodo(_this.state.labelInput);
            _this.setState({ labelInput: undefined });
        };
        _this.onChange = function (evt, newValue) {
            _this.setState({ labelInput: newValue });
        };
        _this.onFilter = function (item) {
            _this.props.setFilter(item.props.headerText);
        };
        _this.state = { labelInput: undefined };
        return _this;
    }
    TodoHeader.prototype.render = function () {
        return (React.createElement(Stack, { gap: 10 },
            React.createElement(Stack, { horizontal: true, horizontalAlign: "center" },
                React.createElement(Text, { variant: "xxLarge" },
                    "todos ",
                    React.createElement(Text, { variant: "mediumPlus" }, "(2.3 exercise)"))),
            React.createElement(Stack, { horizontal: true, gap: 10 },
                React.createElement(Stack.Item, { grow: true },
                    React.createElement(TextField, { placeholder: "What needs to be done?", value: this.state.labelInput, onChange: this.onChange })),
                React.createElement(PrimaryButton, { onClick: this.onAdd }, "Add")),
            React.createElement(Pivot, { onLinkClick: this.onFilter },
                React.createElement(PivotItem, { headerText: "all" }),
                React.createElement(PivotItem, { headerText: "active" }),
                React.createElement(PivotItem, { headerText: "completed" }))));
    };
    return TodoHeader;
}(React.Component));
export { TodoHeader };
